module.exports = __webpack_public_path__ + "static/RyeFlour-585f1081edc157cd17010f019960d78a.webp";